export default __webpack_public_path__ + "static/media/feature-8.eaacb08f.svg";